import { PostAlertsRequest } from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useInfiniteQuery } from '@tanstack/react-query';
import { postAlerts } from '@terminal/services/alerts/event-alerts-service';
import { QUERY_KEY_EVENT_ALERTS } from './event-alerts-query-keys';

export const usePostAlerts = (body: PostAlertsRequest) =>
  useInfiniteQuery({
    queryKey: [QUERY_KEY_EVENT_ALERTS, body],
    queryFn: ({ pageParam }) =>
      postAlerts({ ...body, next: pageParam ?? undefined }),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage): string | null =>
      lastPage?.next_cursor ?? null,
    staleTime: getTimeTillEndOfDayMs(),
  });
